/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuCategoriesForEditPageDocument = gql`
    query getMenuCategoriesForEditPage($companyId: Int!, $branchId: Int!, $menuId: Int, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          categories(onlyTopLevel: true) {
            id
            name(locale: $locale)
            nameOrigin
            favicon {
              id
              path
            }
            parentCategory {
              id
            }
            comment(locale: $locale)
            descriptionOrigin
            deleted
            childCategories(menuId: $menuId, deleted: false) {
              id
              name(locale: $locale)
              nameOrigin
              parentCategory {
                id
              }
              comment(locale: $locale)
              descriptionOrigin
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesForEditPageQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesForEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesForEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesForEditPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuCategoriesForEditPageQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables> & ({ variables: GetMenuCategoriesForEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>(GetMenuCategoriesForEditPageDocument, options);
      }
export function useGetMenuCategoriesForEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>(GetMenuCategoriesForEditPageDocument, options);
        }
export function useGetMenuCategoriesForEditPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>(GetMenuCategoriesForEditPageDocument, options);
        }
export type GetMenuCategoriesForEditPageQueryHookResult = ReturnType<typeof useGetMenuCategoriesForEditPageQuery>;
export type GetMenuCategoriesForEditPageLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesForEditPageLazyQuery>;
export type GetMenuCategoriesForEditPageSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesForEditPageSuspenseQuery>;
export type GetMenuCategoriesForEditPageQueryResult = Apollo.QueryResult<GetMenuCategoriesForEditPageQuery, GetMenuCategoriesForEditPageQueryVariables>;
export const GetAllMenuCategoriesForEditPageDocument = gql`
    query getAllMenuCategoriesForEditPage($companyId: Int!, $locale: String, $menuId: Int, $keepWithoutMenuRelation: Boolean) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      meMenuCategories(
        onlyTopLevel: true
        deleted: false
        menuId: $menuId
        keepWithoutMenuRelation: $keepWithoutMenuRelation
      ) {
        id
        name(locale: $locale)
        nameOrigin
        favicon {
          id
          path
        }
        parentCategory {
          id
        }
        comment(locale: $locale)
        descriptionOrigin
        deleted
        childCategories(deleted: false) {
          id
          name(locale: $locale)
          nameOrigin
          favicon {
            id
          }
          parentCategory {
            id
          }
          comment(locale: $locale)
          descriptionOrigin
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllMenuCategoriesForEditPageQuery__
 *
 * To run a query within a React component, call `useGetAllMenuCategoriesForEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMenuCategoriesForEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMenuCategoriesForEditPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *      menuId: // value for 'menuId'
 *      keepWithoutMenuRelation: // value for 'keepWithoutMenuRelation'
 *   },
 * });
 */
export function useGetAllMenuCategoriesForEditPageQuery(baseOptions: Apollo.QueryHookOptions<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables> & ({ variables: GetAllMenuCategoriesForEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>(GetAllMenuCategoriesForEditPageDocument, options);
      }
export function useGetAllMenuCategoriesForEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>(GetAllMenuCategoriesForEditPageDocument, options);
        }
export function useGetAllMenuCategoriesForEditPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>(GetAllMenuCategoriesForEditPageDocument, options);
        }
export type GetAllMenuCategoriesForEditPageQueryHookResult = ReturnType<typeof useGetAllMenuCategoriesForEditPageQuery>;
export type GetAllMenuCategoriesForEditPageLazyQueryHookResult = ReturnType<typeof useGetAllMenuCategoriesForEditPageLazyQuery>;
export type GetAllMenuCategoriesForEditPageSuspenseQueryHookResult = ReturnType<typeof useGetAllMenuCategoriesForEditPageSuspenseQuery>;
export type GetAllMenuCategoriesForEditPageQueryResult = Apollo.QueryResult<GetAllMenuCategoriesForEditPageQuery, GetAllMenuCategoriesForEditPageQueryVariables>;
export const GetCategoriesForAddDishModalDocument = gql`
    query getCategoriesForAddDishModal($companyId: Int!, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      meMenuCategories(onlyTopLevel: true, deleted: false) {
        id
        name(locale: $locale)
        nameOrigin
        childCategories(deleted: false) {
          id
          name(locale: $locale)
          nameOrigin
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesForAddDishModalQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForAddDishModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForAddDishModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForAddDishModalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCategoriesForAddDishModalQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables> & ({ variables: GetCategoriesForAddDishModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>(GetCategoriesForAddDishModalDocument, options);
      }
export function useGetCategoriesForAddDishModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>(GetCategoriesForAddDishModalDocument, options);
        }
export function useGetCategoriesForAddDishModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>(GetCategoriesForAddDishModalDocument, options);
        }
export type GetCategoriesForAddDishModalQueryHookResult = ReturnType<typeof useGetCategoriesForAddDishModalQuery>;
export type GetCategoriesForAddDishModalLazyQueryHookResult = ReturnType<typeof useGetCategoriesForAddDishModalLazyQuery>;
export type GetCategoriesForAddDishModalSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForAddDishModalSuspenseQuery>;
export type GetCategoriesForAddDishModalQueryResult = Apollo.QueryResult<GetCategoriesForAddDishModalQuery, GetCategoriesForAddDishModalQueryVariables>;
export const GetDishesForAddDishModalDocument = gql`
    query getDishesForAddDishModal($companyId: Int!, $menuId: Int!, $searchCategoryId: Int, $searchDishName: String, $locale: String, $excludeForCategory: Boolean, $excludedCategoryId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuItemsList(
        search: $searchDishName
        menuId: $menuId
        excludeForCategory: $excludeForCategory
        excludedCategoryId: $excludedCategoryId
        categoryId: $searchCategoryId
      ) {
        isAvailableForCurrentMenu(menuId: $menuId)
        id
        name(locale: $locale)
        nameOrigin
        favicon
      }
    }
  }
}
    `;

/**
 * __useGetDishesForAddDishModalQuery__
 *
 * To run a query within a React component, call `useGetDishesForAddDishModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishesForAddDishModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishesForAddDishModalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      menuId: // value for 'menuId'
 *      searchCategoryId: // value for 'searchCategoryId'
 *      searchDishName: // value for 'searchDishName'
 *      locale: // value for 'locale'
 *      excludeForCategory: // value for 'excludeForCategory'
 *      excludedCategoryId: // value for 'excludedCategoryId'
 *   },
 * });
 */
export function useGetDishesForAddDishModalQuery(baseOptions: Apollo.QueryHookOptions<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables> & ({ variables: GetDishesForAddDishModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>(GetDishesForAddDishModalDocument, options);
      }
export function useGetDishesForAddDishModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>(GetDishesForAddDishModalDocument, options);
        }
export function useGetDishesForAddDishModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>(GetDishesForAddDishModalDocument, options);
        }
export type GetDishesForAddDishModalQueryHookResult = ReturnType<typeof useGetDishesForAddDishModalQuery>;
export type GetDishesForAddDishModalLazyQueryHookResult = ReturnType<typeof useGetDishesForAddDishModalLazyQuery>;
export type GetDishesForAddDishModalSuspenseQueryHookResult = ReturnType<typeof useGetDishesForAddDishModalSuspenseQuery>;
export type GetDishesForAddDishModalQueryResult = Apollo.QueryResult<GetDishesForAddDishModalQuery, GetDishesForAddDishModalQueryVariables>;
export const GetMenuItemsByCategoryEditPageDocument = gql`
    query getMenuItemsByCategoryEditPage($companyId: Int!, $categoryId: Int, $menuId: Int!, $locale: String, $isDeletedSupplements: Boolean) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      currency {
        currencySign
      }
      meMenuCategories(id: $categoryId, onlyTopLevel: true, deleted: false) {
        id
        name(locale: $locale)
        nameOrigin
        menuItems(menuId: $menuId) {
          id
          name(locale: $locale)
          nameOrigin
          unit {
            name
          }
          allergens {
            name
          }
          supplements(isDeleted: $isDeletedSupplements) {
            id
            groupName(locale: $locale)
            groupNameOrigin
          }
          description(locale: $locale)
          descriptionOrigin
          favicon
          markers {
            name
            id
            favicon
          }
          composition(locale: $locale)
          compositionOrigin
          portions {
            price
            volume
          }
          cookingTime
        }
        childCategories(menuId: $menuId) {
          id
          name(locale: $locale)
          nameOrigin
          menuItems(menuId: $menuId) {
            id
            name(locale: $locale)
            nameOrigin
            unit {
              name
            }
            allergens {
              name
            }
            supplements(isDeleted: $isDeletedSupplements) {
              id
              groupName(locale: $locale)
              groupNameOrigin
            }
            description(locale: $locale)
            descriptionOrigin
            favicon
            markers {
              name
              id
              favicon
            }
            composition(locale: $locale)
            compositionOrigin
            portions {
              price
              volume
            }
            cookingTime
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemsByCategoryEditPageQuery__
 *
 * To run a query within a React component, call `useGetMenuItemsByCategoryEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemsByCategoryEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemsByCategoryEditPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      categoryId: // value for 'categoryId'
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *      isDeletedSupplements: // value for 'isDeletedSupplements'
 *   },
 * });
 */
export function useGetMenuItemsByCategoryEditPageQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables> & ({ variables: GetMenuItemsByCategoryEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>(GetMenuItemsByCategoryEditPageDocument, options);
      }
export function useGetMenuItemsByCategoryEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>(GetMenuItemsByCategoryEditPageDocument, options);
        }
export function useGetMenuItemsByCategoryEditPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>(GetMenuItemsByCategoryEditPageDocument, options);
        }
export type GetMenuItemsByCategoryEditPageQueryHookResult = ReturnType<typeof useGetMenuItemsByCategoryEditPageQuery>;
export type GetMenuItemsByCategoryEditPageLazyQueryHookResult = ReturnType<typeof useGetMenuItemsByCategoryEditPageLazyQuery>;
export type GetMenuItemsByCategoryEditPageSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemsByCategoryEditPageSuspenseQuery>;
export type GetMenuItemsByCategoryEditPageQueryResult = Apollo.QueryResult<GetMenuItemsByCategoryEditPageQuery, GetMenuItemsByCategoryEditPageQueryVariables>;
export const GetMenuItemsByChildCategoryEditPageDocument = gql`
    query getMenuItemsByChildCategoryEditPage($companyId: Int!, $categoryId: Int, $childCategoryId: Int, $menuId: Int, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      currency {
        currencySign
      }
      meMenuCategories(id: $categoryId, onlyTopLevel: true, deleted: false) {
        id
        childCategories(id: $childCategoryId, deleted: false) {
          id
          parentCategory {
            id
          }
          menuItems(menuId: $menuId) {
            id
            name(locale: $locale)
            nameOrigin
            unit {
              name
            }
            allergens {
              name
            }
            supplements {
              id
              groupName(locale: $locale)
              groupNameOrigin
            }
            description(locale: $locale)
            descriptionOrigin
            favicon
            markers {
              name
              id
              favicon
            }
            composition(locale: $locale)
            compositionOrigin
            portions {
              price
              volume
            }
            cookingTime
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemsByChildCategoryEditPageQuery__
 *
 * To run a query within a React component, call `useGetMenuItemsByChildCategoryEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemsByChildCategoryEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemsByChildCategoryEditPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      categoryId: // value for 'categoryId'
 *      childCategoryId: // value for 'childCategoryId'
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuItemsByChildCategoryEditPageQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables> & ({ variables: GetMenuItemsByChildCategoryEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>(GetMenuItemsByChildCategoryEditPageDocument, options);
      }
export function useGetMenuItemsByChildCategoryEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>(GetMenuItemsByChildCategoryEditPageDocument, options);
        }
export function useGetMenuItemsByChildCategoryEditPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>(GetMenuItemsByChildCategoryEditPageDocument, options);
        }
export type GetMenuItemsByChildCategoryEditPageQueryHookResult = ReturnType<typeof useGetMenuItemsByChildCategoryEditPageQuery>;
export type GetMenuItemsByChildCategoryEditPageLazyQueryHookResult = ReturnType<typeof useGetMenuItemsByChildCategoryEditPageLazyQuery>;
export type GetMenuItemsByChildCategoryEditPageSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemsByChildCategoryEditPageSuspenseQuery>;
export type GetMenuItemsByChildCategoryEditPageQueryResult = Apollo.QueryResult<GetMenuItemsByChildCategoryEditPageQuery, GetMenuItemsByChildCategoryEditPageQueryVariables>;
export const GetCategoriesForModalEditPageDocument = gql`
    query getCategoriesForModalEditPage($companyId: Int!, $branchId: Int!, $menuId: Int, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          categoriesNotInMenu(onlyTopLevel: true) {
            id
            name(locale: $locale)
            nameOrigin
            isExistsInMenu(menuId: $menuId)
            parentCategory {
              id
            }
            childCategories(menuId: $menuId, excludeChildren: true) {
              id
              name(locale: $locale)
              nameOrigin
              parentCategory {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesForModalEditPageQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForModalEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForModalEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForModalEditPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCategoriesForModalEditPageQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables> & ({ variables: GetCategoriesForModalEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>(GetCategoriesForModalEditPageDocument, options);
      }
export function useGetCategoriesForModalEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>(GetCategoriesForModalEditPageDocument, options);
        }
export function useGetCategoriesForModalEditPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>(GetCategoriesForModalEditPageDocument, options);
        }
export type GetCategoriesForModalEditPageQueryHookResult = ReturnType<typeof useGetCategoriesForModalEditPageQuery>;
export type GetCategoriesForModalEditPageLazyQueryHookResult = ReturnType<typeof useGetCategoriesForModalEditPageLazyQuery>;
export type GetCategoriesForModalEditPageSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForModalEditPageSuspenseQuery>;
export type GetCategoriesForModalEditPageQueryResult = Apollo.QueryResult<GetCategoriesForModalEditPageQuery, GetCategoriesForModalEditPageQueryVariables>;
export const GetIsAnyItemsPerMenuDocument = gql`
    query getIsAnyItemsPerMenu($companyId: Int!, $branchId: Int!, $menuId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          isAnyItems
        }
      }
    }
  }
}
    `;

/**
 * __useGetIsAnyItemsPerMenuQuery__
 *
 * To run a query within a React component, call `useGetIsAnyItemsPerMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsAnyItemsPerMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsAnyItemsPerMenuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useGetIsAnyItemsPerMenuQuery(baseOptions: Apollo.QueryHookOptions<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables> & ({ variables: GetIsAnyItemsPerMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>(GetIsAnyItemsPerMenuDocument, options);
      }
export function useGetIsAnyItemsPerMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>(GetIsAnyItemsPerMenuDocument, options);
        }
export function useGetIsAnyItemsPerMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>(GetIsAnyItemsPerMenuDocument, options);
        }
export type GetIsAnyItemsPerMenuQueryHookResult = ReturnType<typeof useGetIsAnyItemsPerMenuQuery>;
export type GetIsAnyItemsPerMenuLazyQueryHookResult = ReturnType<typeof useGetIsAnyItemsPerMenuLazyQuery>;
export type GetIsAnyItemsPerMenuSuspenseQueryHookResult = ReturnType<typeof useGetIsAnyItemsPerMenuSuspenseQuery>;
export type GetIsAnyItemsPerMenuQueryResult = Apollo.QueryResult<GetIsAnyItemsPerMenuQuery, GetIsAnyItemsPerMenuQueryVariables>;
export const GetCategoriesInMenuDocument = gql`
    query getCategoriesInMenu($companyId: Int!, $branchId: Int!, $menuId: Int!, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          categories(onlyTopLevel: true) {
            id
            name(locale: $locale)
            childCategories(menuId: $menuId) {
              id
              name(locale: $locale)
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesInMenuQuery__
 *
 * To run a query within a React component, call `useGetCategoriesInMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesInMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesInMenuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCategoriesInMenuQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables> & ({ variables: GetCategoriesInMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>(GetCategoriesInMenuDocument, options);
      }
export function useGetCategoriesInMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>(GetCategoriesInMenuDocument, options);
        }
export function useGetCategoriesInMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>(GetCategoriesInMenuDocument, options);
        }
export type GetCategoriesInMenuQueryHookResult = ReturnType<typeof useGetCategoriesInMenuQuery>;
export type GetCategoriesInMenuLazyQueryHookResult = ReturnType<typeof useGetCategoriesInMenuLazyQuery>;
export type GetCategoriesInMenuSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesInMenuSuspenseQuery>;
export type GetCategoriesInMenuQueryResult = Apollo.QueryResult<GetCategoriesInMenuQuery, GetCategoriesInMenuQueryVariables>;
export const ManageMenuCategoryRelationDocument = gql`
    mutation manageMenuCategoryRelation($companyId: Int!, $menuId: Int!, $input: MenuCategoryRelationSingleInput!, $branchId: Int!) {
  manageMenuCategoryRelation(
    companyId: $companyId
    menuId: $menuId
    input: $input
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type ManageMenuCategoryRelationMutationFn = Apollo.MutationFunction<ManageMenuCategoryRelationMutation, ManageMenuCategoryRelationMutationVariables>;

/**
 * __useManageMenuCategoryRelationMutation__
 *
 * To run a mutation, you first call `useManageMenuCategoryRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageMenuCategoryRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageMenuCategoryRelationMutation, { data, loading, error }] = useManageMenuCategoryRelationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      menuId: // value for 'menuId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useManageMenuCategoryRelationMutation(baseOptions?: Apollo.MutationHookOptions<ManageMenuCategoryRelationMutation, ManageMenuCategoryRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageMenuCategoryRelationMutation, ManageMenuCategoryRelationMutationVariables>(ManageMenuCategoryRelationDocument, options);
      }
export type ManageMenuCategoryRelationMutationHookResult = ReturnType<typeof useManageMenuCategoryRelationMutation>;
export type ManageMenuCategoryRelationMutationResult = Apollo.MutationResult<ManageMenuCategoryRelationMutation>;
export type ManageMenuCategoryRelationMutationOptions = Apollo.BaseMutationOptions<ManageMenuCategoryRelationMutation, ManageMenuCategoryRelationMutationVariables>;
export const UpdateMenuCategoryDocument = gql`
    mutation updateMenuCategory($companyId: Int!, $id: Int!, $input: MenuCategoryInput!, $branchId: Int!, $locale: String) {
  updateMenuCategory(
    companyId: $companyId
    id: $id
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type UpdateMenuCategoryMutationFn = Apollo.MutationFunction<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;

/**
 * __useUpdateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCategoryMutation, { data, loading, error }] = useUpdateMenuCategoryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>(UpdateMenuCategoryDocument, options);
      }
export type UpdateMenuCategoryMutationHookResult = ReturnType<typeof useUpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationResult = Apollo.MutationResult<UpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;
export const ManageMenuItemCategoryRelationDocument = gql`
    mutation manageMenuItemCategoryRelation($companyId: Int!, $menuId: Int!, $input: MenuItemCategoryRelationInput!, $branchId: Int!) {
  manageMenuItemCategoryRelation(
    companyId: $companyId
    menuId: $menuId
    input: $input
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type ManageMenuItemCategoryRelationMutationFn = Apollo.MutationFunction<ManageMenuItemCategoryRelationMutation, ManageMenuItemCategoryRelationMutationVariables>;

/**
 * __useManageMenuItemCategoryRelationMutation__
 *
 * To run a mutation, you first call `useManageMenuItemCategoryRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageMenuItemCategoryRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageMenuItemCategoryRelationMutation, { data, loading, error }] = useManageMenuItemCategoryRelationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      menuId: // value for 'menuId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useManageMenuItemCategoryRelationMutation(baseOptions?: Apollo.MutationHookOptions<ManageMenuItemCategoryRelationMutation, ManageMenuItemCategoryRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageMenuItemCategoryRelationMutation, ManageMenuItemCategoryRelationMutationVariables>(ManageMenuItemCategoryRelationDocument, options);
      }
export type ManageMenuItemCategoryRelationMutationHookResult = ReturnType<typeof useManageMenuItemCategoryRelationMutation>;
export type ManageMenuItemCategoryRelationMutationResult = Apollo.MutationResult<ManageMenuItemCategoryRelationMutation>;
export type ManageMenuItemCategoryRelationMutationOptions = Apollo.BaseMutationOptions<ManageMenuItemCategoryRelationMutation, ManageMenuItemCategoryRelationMutationVariables>;
export const UpdateMenuItemDocument = gql`
    mutation updateMenuItem($companyId: Int!, $menuId: Int!, $input: MenuItemInput!, $branchId: Int!, $locale: String) {
  updateMenuItem(
    companyId: $companyId
    id: $menuId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type UpdateMenuItemMutationFn = Apollo.MutationFunction<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;

/**
 * __useUpdateMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemMutation, { data, loading, error }] = useUpdateMenuItemMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      menuId: // value for 'menuId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>(UpdateMenuItemDocument, options);
      }
export type UpdateMenuItemMutationHookResult = ReturnType<typeof useUpdateMenuItemMutation>;
export type UpdateMenuItemMutationResult = Apollo.MutationResult<UpdateMenuItemMutation>;
export type UpdateMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;
export const CloneMenuItemInMenuContentDocument = gql`
    mutation cloneMenuItemInMenuContent($companyId: Int!, $cloneMenuItemId: Int!, $input: MenuItemCloneInput!, $branchId: Int!, $locale: String) {
  cloneMenuItemNew(
    companyId: $companyId
    cloneMenuItemId: $cloneMenuItemId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type CloneMenuItemInMenuContentMutationFn = Apollo.MutationFunction<CloneMenuItemInMenuContentMutation, CloneMenuItemInMenuContentMutationVariables>;

/**
 * __useCloneMenuItemInMenuContentMutation__
 *
 * To run a mutation, you first call `useCloneMenuItemInMenuContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneMenuItemInMenuContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneMenuItemInMenuContentMutation, { data, loading, error }] = useCloneMenuItemInMenuContentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      cloneMenuItemId: // value for 'cloneMenuItemId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCloneMenuItemInMenuContentMutation(baseOptions?: Apollo.MutationHookOptions<CloneMenuItemInMenuContentMutation, CloneMenuItemInMenuContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneMenuItemInMenuContentMutation, CloneMenuItemInMenuContentMutationVariables>(CloneMenuItemInMenuContentDocument, options);
      }
export type CloneMenuItemInMenuContentMutationHookResult = ReturnType<typeof useCloneMenuItemInMenuContentMutation>;
export type CloneMenuItemInMenuContentMutationResult = Apollo.MutationResult<CloneMenuItemInMenuContentMutation>;
export type CloneMenuItemInMenuContentMutationOptions = Apollo.BaseMutationOptions<CloneMenuItemInMenuContentMutation, CloneMenuItemInMenuContentMutationVariables>;
export type GetMenuCategoriesForEditPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuCategoriesForEditPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null }> | null }> | null }> | null }> | null } | null } | null };

export type GetAllMenuCategoriesForEditPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  keepWithoutMenuRelation?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAllMenuCategoriesForEditPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null }> | null }> | null } | null } | null };

export type GetCategoriesForAddDishModalQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesForAddDishModalQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null }> | null }> | null } | null } | null };

export type GetDishesForAddDishModalQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
  searchCategoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  searchDishName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  excludeForCategory?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  excludedCategoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetDishesForAddDishModalQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuItemsList?: Array<{ __typename?: 'MenuItemProxy', isAvailableForCurrentMenu: boolean, id: number, name?: string | null, nameOrigin?: string | null, favicon?: string | null } | null> | null } | null } | null };

export type GetMenuItemsByCategoryEditPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menuId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isDeletedSupplements?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetMenuItemsByCategoryEditPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', currency?: { __typename?: 'CurrencyProxy', currencySign?: string | null } | null, meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, menuItems?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, description?: string | null, descriptionOrigin?: string | null, favicon?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, unit: { __typename?: 'UnitProxy', name: string }, allergens?: Array<{ __typename?: 'MenuAllergenProxy', name: string }> | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null }> | null, markers?: Array<{ __typename?: 'MenuMarkerProxy', name: string, id: number, favicon?: string | null }> | null, portions?: Array<{ __typename?: 'MenuItemPortionProxy', price: number, volume: number }> | null }> | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, menuItems?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, description?: string | null, descriptionOrigin?: string | null, favicon?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, unit: { __typename?: 'UnitProxy', name: string }, allergens?: Array<{ __typename?: 'MenuAllergenProxy', name: string }> | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null }> | null, markers?: Array<{ __typename?: 'MenuMarkerProxy', name: string, id: number, favicon?: string | null }> | null, portions?: Array<{ __typename?: 'MenuItemPortionProxy', price: number, volume: number }> | null }> | null }> | null }> | null } | null } | null };

export type GetMenuItemsByChildCategoryEditPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  childCategoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuItemsByChildCategoryEditPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', currency?: { __typename?: 'CurrencyProxy', currencySign?: string | null } | null, meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null, menuItems?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, description?: string | null, descriptionOrigin?: string | null, favicon?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, unit: { __typename?: 'UnitProxy', name: string }, allergens?: Array<{ __typename?: 'MenuAllergenProxy', name: string }> | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null }> | null, markers?: Array<{ __typename?: 'MenuMarkerProxy', name: string, id: number, favicon?: string | null }> | null, portions?: Array<{ __typename?: 'MenuItemPortionProxy', price: number, volume: number }> | null }> | null }> | null }> | null } | null } | null };

export type GetCategoriesForModalEditPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesForModalEditPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', categoriesNotInMenu?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, isExistsInMenu: boolean, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number } | null }> | null }> | null }> | null }> | null } | null } | null };

export type GetIsAnyItemsPerMenuQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
}>;


export type GetIsAnyItemsPerMenuQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', isAnyItems: boolean }> | null }> | null } | null } | null };

export type GetCategoriesInMenuQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesInMenuQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null }> | null }> | null }> | null }> | null } | null } | null };

export type ManageMenuCategoryRelationMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
  input: Types.MenuCategoryRelationSingleInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type ManageMenuCategoryRelationMutation = { __typename?: 'Mutation', manageMenuCategoryRelation: { __typename?: 'MenuProxy', id: number } };

export type UpdateMenuCategoryMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
  input: Types.MenuCategoryInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateMenuCategoryMutation = { __typename?: 'Mutation', updateMenuCategory: { __typename?: 'MenuCategoryProxy', id: number } };

export type ManageMenuItemCategoryRelationMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
  input: Types.MenuItemCategoryRelationInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type ManageMenuItemCategoryRelationMutation = { __typename?: 'Mutation', manageMenuItemCategoryRelation: { __typename?: 'MenuProxy', id: number } };

export type UpdateMenuItemMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  menuId: Types.Scalars['Int']['input'];
  input: Types.MenuItemInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateMenuItemMutation = { __typename?: 'Mutation', updateMenuItem: { __typename?: 'MenuItemProxy', id: number } };

export type CloneMenuItemInMenuContentMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  cloneMenuItemId: Types.Scalars['Int']['input'];
  input: Types.MenuItemCloneInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CloneMenuItemInMenuContentMutation = { __typename?: 'Mutation', cloneMenuItemNew: { __typename?: 'MenuItemProxy', id: number } };
